import Icon from '../components/Icon.vue'

Icon.register({
  'user-secret': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M383.9 308.3L407.8 245.7C411.8 235.2 404.1 224 392.8 224H334.3C345.3 205.1 352.1 183.4 352.1 160V159.7C391.3 151.9 416.1 140.6 416.1 128 416.1 114.7 388.8 102.9 346 95 336.8 62.2 319 29.2 305.4 12.2 295.9 0.3 279.5-3.4 265.9 3.4L238.3 17.2C229.3 21.7 218.7 21.7 209.7 17.2L182.1 3.4C168.5-3.4 152.1 0.3 142.6 12.2 129.1 29.2 111.2 62.2 102 95 59.3 102.9 32 114.7 32 128 32 140.6 56.8 151.9 96 159.7V160C96 183.4 102.8 205.1 113.8 224H56.3C44.8 224 37.1 235.7 41.6 246.3L67.4 306.5C27.3 329.8 0 372.7 0 422.4V467.2C0 491.9 20.1 512 44.8 512H403.2C427.9 512 448 491.9 448 467.2V422.4C448 374 422.2 332 383.9 308.3zM176 480L134.4 288 184 320 208 360 176 480zM272 480L240 360 264 320 313.6 288 272 480zM313.7 181.5C309.8 193.4 306.7 206.1 297.2 214.9 287.1 224.2 249.2 237.3 233.2 189.9 230.4 181.5 217.8 181.5 214.9 189.9 197.9 240.1 158.9 222.3 150.9 214.9 141.4 206.1 138.2 193.4 134.4 181.5 133.6 179 128.1 175.8 128.1 175.7V164.9C156.4 168.5 189.1 170.7 224.1 170.7S291.8 168.6 320.1 164.9V175.7C320 175.8 314.5 178.9 313.7 181.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-secret.js
// module id = iG0C
// module chunks = 144